export default function Badge({ children, variant = 'info', className = '' }) {
  const variantClass = `badge-${variant}`;

  return (
    <span className={`badge ${variantClass} ${className}`}>
      {children}
    </span>
  );
}
